export const messages = {
  en: {
    copyWork: {
      search: {
        title: 'Search Conditions',
        workName: 'Work Order Name',
        createUser: 'Creator',
        startTime: 'Start Time',
        endTime: 'End Time'
      },
      list: {
        title: 'Work Orders Copied to Me'
      },
      table: {
        id: 'ID',
        workName: 'Work Order Name',
        typeName: 'Type Name',
        workCycle: 'Cycle',
        startTime: 'Start Time',
        endTime: 'End Time',
        createUser: 'Creator',
        handler: 'Handler',
        copyUser: 'Copy To',
        status: 'Status',
        createTime: 'Create Time'
      },
      state: {
        all: 'All',
        W: 'Pending',
        C: 'Processed'
      },
      cycle: {
        once: 'One-time',
        periodic: 'Periodic'
      },
      audit: {
        title: 'Read Note',
        message: 'Note',
        messagePlaceholder: 'Required, please fill in the note'
      },
      fetchError: 'Failed to fetch work orders'
    }
  },
  zh: {
    copyWork: {
      search: {
        title: '查询条件',
        workName: '工单名称',
        createUser: '发起人',
        startTime: '开始时间',
        endTime: '结束时间'
      },
      list: {
        title: '抄送我的工作单'
      },
      table: {
        id: '编号',
        workName: '工单名称',
        typeName: '类型名称',
        workCycle: '标识',
        startTime: '开始时间',
        endTime: '结束时间',
        createUser: '发起人',
        handler: '处理人',
        copyUser: '抄送人',
        status: '状态',
        createTime: '创建时间'
      },
      state: {
        all: '全部',
        W: '待处理',
        C: '已处理'
      },
      cycle: {
        once: '一次性工单',
        periodic: '周期性工单'
      },
      audit: {
        title: '已阅说明',
        message: '说明',
        messagePlaceholder: '必填，请填写说明'
      },
fetchError: '获取工单列表失败'
    }
  },
  'zh-TW': {
    copyWork: {
      search: {
        title: '查詢條件',
        workName: '工單名稱',
        createUser: '發起人',
        startTime: '開始時間',
        endTime: '結束時間'
      },
      list: {
        title: '抄送我的工作單'
      },
      table: {
        id: '編號',
        workName: '工單名稱',
        typeName: '類型名稱',
        workCycle: '標識',
        startTime: '開始時間',
        endTime: '結束時間',
        createUser: '發起人',
        handler: '處理人',
        copyUser: '抄送人',
        status: '狀態',
        createTime: '創建時間'
      },
      state: {
        all: '全部',
        W: '待處理',
        C: '已處理'
      },
      cycle: {
        once: '一次性工單',
        periodic: '周期性工單'
      },
      audit: {
        title: '已閱說明',
        message: '說明',
        messagePlaceholder: '必填，請填寫說明'
      },
fetchError: '獲取工單列表失敗'
    }
  },
  'zh-TW': {
    copyWork: {
      search: {
        title: '查詢條件',
        workName: '工單名稱',
        createUser: '發起人',
        startTime: '開始時間',
        endTime: '結束時間'
      },
      list: {
        title: '抄送我的工作單'
      },
      table: {
        id: '編號',
        workName: '工單名稱',
        typeName: '類型名稱',
        workCycle: '標識',
        startTime: '開始時間',
        endTime: '結束時間',
        createUser: '發起人',
        handler: '處理人',
        copyUser: '抄送人',
        status: '狀態',
        createTime: '創建時間'
      },
      state: {
        all: '全部',
        W: '待處理',
        C: '已處理'
      },
      cycle: {
        once: '一次性工單',
        periodic: '周期性工單'
      },
      audit: {
        title: '已閱說明',
        message: '說明',
        messagePlaceholder: '必填，請填寫說明'
      },
      fetchError: '獲取工單列表失敗'
    }
  }
}